import { Injectable } from '@angular/core';
import { DroneOperator } from '@mocca-technologies/model';

export interface PendingOperatorEdit {
  operator: DroneOperator;
  isSubOperator: boolean;
}

@Injectable({ providedIn: 'root' })
export class NavigationStateService {
    stopEnrolment = false;
    isAuth = true;
    pendingOperatorEdit: PendingOperatorEdit | null = null;

    clear() {
        this.stopEnrolment = false;
        this.isAuth = true;
        this.pendingOperatorEdit = null;
    }
}
